import React, { useContext } from 'react';
import { getCurrency } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { useAppContext } from 'Context/ReactAppContext';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';

export const UpliftPrice = ({ className = '', currency, iconClassname, ...props }) => {
  const { locale, language } = useAppContext();
  const { currency: defaultCurrency } = useContext(PaymentInfoContext);
  const { symbol } = getCurrency(locale, currency || defaultCurrency);
  const isFrench = language === 'fr';

  return (
    <span className={classnames('none cursor-pointer', className)} {...props}>
      {!isFrench && symbol}
      <span data-up-from-currency-unit-major=""></span>
      {isFrench && symbol}/mo
      <span data-up-tooltip="" className={classnames('absolute', iconClassname)}>
        <Icon name={ICONS.INFORMATION} width="1.5rem" />
      </span>
    </span>
  );
};
